import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { CreateServicePayload } from "../../payload/CreateService/CreateServicePayload";

const createServicesFetch = (state: ServiceState, action: PayloadAction<CreateServicePayload>) => {
    state.isLoading = true;
}

export default createServicesFetch;